// extracted by mini-css-extract-plugin
module.exports = {"listContainer":"_3Dtjgcu","dataRow":"_Q-kdypm","icon":"_3ZgVHHz","text":"_2ik7n4M","textLink":"_3V4URaj"};